<template>
    <div id="trunk">
        <template>
            <lead :headOption="headOption" />
            <main class="main maxW">
                <div class="test-nav">
                    <div class="test-location">
                        <span>当前定位：</span>
                        <el-select v-model="subjectID" placeholder="请选择" @change="getSubject">
                            <el-option v-for="item of subjectlist" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="test-link">
                        <router-link to="/test" :class="isActive('test') ? 'showActive' : ''">首页</router-link>
                        <router-link to="/test/manual" :class="isActive('manual') ? 'showActive' : ''">手动组卷</router-link>
                        <router-link to="/test/intelligent" :class="isActive('intelligent') ? 'showActive' : ''">智能组卷</router-link>
                        <router-link to="/test/item-bank" :class="isActive('item-bank') ? 'showActive' : ''">题库</router-link>
                        <router-link to="/test/common-library" class="library" :class="isActive('common-library') ? 'showActive' : ''">卷库</router-link>
                    </div>
                </div>
                <div class="test-template">
                    <router-view />
                </div>
            </main>
            <foote />
        </template>

        <div id="backtop" @click='returnTop'>
            <i class="el-icon-caret-top"></i>
        </div>
    </div>
</template>
<script>
import lead from "@/components/common/head";
import foote from "@/components/common/footer";
export default {
    components: { lead, foote },
    data() {
        return {
            disabled: true,
            subjectID: 0,
            /* 科目id */
            subjectlist: [],
            /* 科目数据 */
            // 顶部模块标题：
            headOption: {
                link: "/test",
                title: "组卷"
            },

            timer: null,
            bSys: true,
        };
    },

    created() {
        this.getUserLabel()
    },
    mounted() {
        // 当网页向下滑动 20px 出现"返回顶部" 按钮
        // 
        document.addEventListener('scroll',  ()=>{
            this.scrollFunction()
        },false)

    },
    computed: {
        /*路由导航高亮*/
        isActive (){
            return (name)=> {
                let route = this.$route;
                if (name == route.name){
                    return true;
                }

                if (name == 'item-bank' && route.name == 'private-bank'){
                    return true;
                }

                if (name == 'common-library' && route.name == 'private-library'){
                    return true;
                }

                return false;
            }

        }
    },
    methods: {
        scrollFunction() {
            if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
                document.getElementById("backtop").style.visibility = "visible";
            } else {
                document.getElementById("backtop").style.visibility = "hidden";
            }
        },

        // 点击按钮，返回顶部
        returnTop() {
            this.timer = setInterval(() => {
                var scrollTop = document.documentElement.scrollTop || document.body.scrollTop; //获取滚动条距离顶部高度
                var iSpeed = Math.floor((0 - scrollTop) / 9); //Math.floor()向下取整   (0-scrollTop)表示：获取滚动条距离顶部高度的负值

                this.bSys = true; //意味着是系统在滚动，而不是用户


                document.documentElement.scrollTop = scrollTop + iSpeed; //设置滚动条距离顶部位置

                //当滚动条到达顶部，关闭定时器
                if (scrollTop == 0) {
                    clearInterval(this.timer);
                }
            }, 30);
        },
        getUserLabel() {
            let success = (data => {
                this.subjectID = data.data[0].sub_id ? data.data[0].sub_id : 0;
                if (this.subjectID == 0) { this.disabled = false }
                this.getSubject()
            })
            let params = {
                id: this.$store.getters.userInfo.id,
                userid: this.$g.user_id
            }
            //执行请求，并将回调方法变成config成员以便鉴权过期可以执行
            this.$ajax.get('api/user/user', { params: params, func: { success: success } })
        },
        /**
         * 请求科目的数据
         * @author lucky
         * @DateTime 2019-07-22T11:12:14+0800
         * @return   {[type]}                 [description]
         */
        getSubject() {

            let success = (res => {
                this.subjectlist = res.data;
                if (this.subjectlist.length > 0) {
                    this.subjectlist.unshift({ name: '全部', id: 0 })
                };

                console.log(this.subjectlist)
                sessionStorage.setItem('subjectID', this.subjectID)
                this.$store.commit('SET_QUESTIONCHANGE', new Date())
            });

            let params = {
                type: 2,
                // org_id: 0,
                status: 1,
            }

            this.$ajax({
                url: 'api/cate/subject',
                method: 'get',
                params: params,
                func: { success: success }
            })
        }
    },

};
</script>
<style lang="scss">
.main {
    box-sizing: border-box;
    min-height: calc(100vh - 124px);
    padding: 25px 0 40px;
}

@import "@/assets/css/test.scss";
</style>